export const DEFAULT_STATUSES = ['held', 'needs-update', 'rejected'];

// Note: these should match the server's enum in src/claims/domain/types.ts:Status
export const CLAIM_STATUSES = [
  'unknown',
  'duplicate',
  'feature-off',
  'configuration-error',
  'gateway-disabled',
  'pending',
  'held',
  'needs-update',
  'submitted',
  'rejected',
];
